import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as LogoSVG } from "../../../../../images/svg/public/numberSystem/logo.svg";
import { OrderPreparationStatusName } from "../../../../../services/Api/Organization/types";
import { NumberOrderApi } from "../../../../../services/Api/Public/types";
import { getNumberSystemClassName, getNumberSystemFilteredItemsByStatuses } from "../utils";
import NumberSystemEmptyData from "./NumberSystemEmptyData";
import NumberSystemSection from "./NumberSystemSection";

interface Props {
	items: NumberOrderApi[];
	itemsLoading: boolean;
	showItems: boolean;
}

const NumberSystemContainer = ({ items, itemsLoading, showItems }: Props) => {
	const { t } = useTranslation();

	return (
		<>
			{items.length === 0 && <NumberSystemEmptyData loading={itemsLoading} />}
			{items.length > 0 && showItems && (
				<div className="d-flex p-4 number-system-inner-container">
					<div className="d-flex justify-content-between w-100">
						<div className="d-flex flex-column w-100 ">
							<div className="w-100 d-grid headers-container">
								<h1
									className={`mb-4 ${getNumberSystemClassName(
										getNumberSystemFilteredItemsByStatuses(items, [
											OrderPreparationStatusName.IN_PROGRESS,
											OrderPreparationStatusName.READY,
											OrderPreparationStatusName.NEW,
										])[0]
									)}`}
								>
									{t("enums.preparation_statuses.IN_PROGRESS")}
								</h1>
								<h1
									className={`mb-4 ${getNumberSystemClassName(
										getNumberSystemFilteredItemsByStatuses(items, [
											OrderPreparationStatusName.PACKED,
										])[0]
									)}`}
								>
									{t("enums.preparation_statuses.READY")}
								</h1>
							</div>
							<div className="number-system-items w-100">
								<NumberSystemSection
									items={getNumberSystemFilteredItemsByStatuses(items, [
										OrderPreparationStatusName.IN_PROGRESS,
										OrderPreparationStatusName.READY,
										OrderPreparationStatusName.NEW,
									])}
								/>
								<NumberSystemSection
									items={getNumberSystemFilteredItemsByStatuses(items, [
										OrderPreparationStatusName.PACKED,
									])}
								/>
							</div>
						</div>
						<div className="ms-5 d-flex align-items-end logo">
							<LogoSVG />
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default NumberSystemContainer;
